module.exports = __webpack_public_path__ + "img/加盟店.331757af.svg";